<template>
  <layout-default> 
    <div class="container py-6 wishlist-page">
      <div class="wishlist-header border-2 border-bottom mb-5">
        <Breadcrumb />
        <h1 class="title mt-2">{{$t('wishlist.title')}}</h1>
      </div>
      
      <div v-if="!hasItems" class="empty-state p-6 text-center">
        <p>{{$t('wishlist.empty')}}</p>
      </div>
      <div v-else class="wishlist-items">
        <div
          v-for="(item, key) in wishlistItems"
          :key="key"
          class="wishlist-item mb-4 p-4 border rounded"
        >
          <div class="wishlist-item-inner d-flex justify-content-between align-items-center gap-5">
              <link-wrapper class="product-link text-decoration-none removeDecorations flex-grow-1" :location="productURL(key)">
                <div class="d-flex flex-column">
                  <div class="d-flex">
                    <div class="image-wrapper me-4">
                      <img
                        v-if="hasImage(item)"
                        class="item-img"
                        :src="$getFileSource(item.immagine[0].path)"
                        :alt="item.descrizione || item.codice"
                      />
                      <div v-else class="placeholder-img d-flex justify-content-center align-items-center">
                        No Image
                      </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-start">
                        <h2 class="fs-5 mb-1 fw-bold">{{ item?._prodotto?.[0]?.nome }}</h2>
                        <p class="mb-1 truncate-multiline">{{ item.descrizione }}</p>
                    </div>
                  </div>
                  <div class="attribute-wrapper d-flex gap-5 mt-2 mb-1">
                    <div class="attribute d-flex">
                        <strong>{{$t('product.price')}}:</strong><span> {{ $convertCurrency(item.prezzo) }}</span>
                    </div>
                    <div class="attribute d-flex">
                        <strong>{{$t('product.size') || 'Size'}}:</strong><span> {{ item.taglia }}</span>
                    </div>
                    <div class="attribute d-flex">
                        <strong>{{$t('product.color') || 'Color'}}:</strong><span> {{ item.colore }}</span>
                    </div>
                  </div>
                </div>
              </link-wrapper>
              <div class="mt-2 d-flex gap-3 icon-cards">
                <tool-tip :content="$t('wishlist.remove')" :interactive="false" placement="top">
                  <font-awesome-icon
                    @click="removeItem(key)"
                    class="fa-2x icon rounded-circle text-white wrapper active play"
                    :icon="['fas', 'heart']"
                  />
                </tool-tip>
              </div>
            </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";
import ToolTip from "../../components/atoms/ToolTip.vue";
import Breadcrumb from "../../components/atoms/Breadcrumb/Breadcrumb.vue";
import { removeFromWishlist } from "../../composables/manageWishlist";
import LinkWrapper from "../../components/atoms/LinkWrapper/LinkWrapper.vue";

export default {
  components: {
    LayoutDefault,
    FontAwesomeIcon,
    Breadcrumb,
    LinkWrapper,
    ToolTip
  },
  computed: {
    wishlistItems() {
      return this.$store.state.wishlist.wishItems || {};
    },
    hasItems() {
      return Object.keys(this.wishlistItems).length > 0;
    },
  },
  methods: {
    hasImage(item) {
      return (
        item.immagine &&
        Array.isArray(item.immagine) &&
        item.immagine.length > 0 &&
        item.immagine[0]?.path
      );
    },
    async removeItem(id) {
      if (!id) return;
      await removeFromWishlist(id);
    },
    productURL(key) {
      const [pId, vId] = key.split("-");
      return this.$buildProductURL(pId, vId);
    },
  },
};
</script>

<style scoped>
.truncate-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wishlist-page {
  margin-bottom: 45px;
}
.wishlist-header {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.title {
  font-weight:600!important;
}
.wishlist-item {
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  gap: 16px;
}
.item-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
.placeholder-img {
  width: 80px;
  height: 80px;
  background: #f0f0f0;
  font-size: 12px;
  color: #666;
}
@media screen and (max-width: 768px) {
  .attribute-wrapper{
    flex-direction: column;
    gap: 0.5rem !important;
  }
  .attribute-wrapper .attribute{
    justify-content: space-between;
  }
  .wishlist-items .wishlist-item .wishlist-item-inner{
    flex-direction: column-reverse;
    gap: 2rem !important;
  }
  .wishlist-items .wishlist-item .wishlist-item-inner .product-link{
      width: 100%;
  }
}
</style>

<style>
.play {
  animation-fill-mode: forwards;
  animation-name: bounce;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation-delay: 1ms;
}
.play svg {
  animation-fill-mode: forwards;
  animation-name: bounce;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation-delay: 1ms;
}
@keyframes bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce2 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped="scoped">
.wrapper {
  width: 30px;
  height: 30px;
  cursor: pointer;
  background-color: white;
  transition-duration: 0.25s;
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  color: #484848 !important;
}
.wrapper svg {
  width: 12px;
  height: 12px;
}
.wrapper.active {
  background-color: var(--primary-color) !important;
  color: white !important;
}
.wrapper:hover {
  background-color: var(--primary-color);
  transition-duration: 0.25s;
  color: #f2f2f2 !important;
}

@media (max-width: 980px) {
  .wrapper {
    width: 24px;
    height: 24px;
  }
}
</style>

<style scoped="scoped">
.icon-cards:not(.d-flex) > svg:not(:first-child) {
  margin-top: 10px;
  display: block;
}
.icon-cards.d-flex > svg:not(:first-child) {
  margin-left: 20px;
}
.icon-cards > svg {
  cursor: pointer;
}
.icon-cards svg {
  width: 45px;
  height: 45px;
}
.icon {
  padding: 10px;
}
.fa-heart {
  background-color: white;
  transition-duration: 0.25s;
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  color: #484848 !important;
}
.fa-heart:hover,
.active {
  background-color: var(--primary-color);
  transition-duration: 0.25s;
  color: #f2f2f2 !important;
}
</style>
